import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {takeUntil} from "rxjs/operators";
import {WaitingGoods} from "../../interfaces/waiting-goods";
import {BaseService} from "../../services/base.service";
import {HttpClient} from "@angular/common/http";
import {Subject} from "rxjs";
import {cloneDeep} from 'lodash';
import * as moment from "moment/moment";
import {GoodsService} from "../../services/goods.service";

@Component({
  selector: 'app-modal-expected-receipt-goods',
  templateUrl: './modal-expected-receipt-goods.component.html',
  styleUrls: ['./modal-expected-receipt-goods.component.scss']
})
export class ModalExpectedReceiptGoodsComponent extends BaseService implements OnDestroy {
  @Input() waitingGoods = [];

  public isDestroyed: Subject<boolean> = new Subject<boolean>();
  public filterWaitingGoods: string = '';
  public filteredWaitingGoods= [];
  public isModalExpectedReceiptOfGoodsShow: boolean = false;
  public isDarkBackground: boolean = false;
  public groupedWaitingGoods = [];
  public waitingGoodsNoDate= [];

  constructor(
    private http: HttpClient,
    private goodsService: GoodsService,
  ) {
    super();
  }

  openModalWaitingGoodsShow() {
    // список нижче показується повністю - пошук минулого відкриття в полі лишався, хоча вже не фільтрував
    this.filterWaitingGoods = '';

    this.http.get(this.apiRoot + 'header/waiting_goods')
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((data: WaitingGoods) => {
        // порожній список бек віддає як data: 0 - розгортання [...0] падало з TypeError
        this.waitingGoods = Array.isArray(data.data) ? data.data : [];

        this.filteredWaitingGoods = [...this.waitingGoods];

        const pack_ids: number[] = [];

        for (const good of this.filteredWaitingGoods) {
          if (good.pack_id) {
            pack_ids.push(Number(good.pack_id));
          }
        }

        // на порожній pack_ids get_arrivals_datas відповідає success: false без data
        if (!pack_ids.length) {
          this.rebuildGroups(this.filteredWaitingGoods);
          return;
        }

        this.http.post(this.apiRoot + 'good/get_arrivals_datas', {
          pack_ids,
        })
          .pipe(takeUntil(this.isDestroyed))
          .subscribe((resp: any) => {
            const waitingDateByWar = this.goodsService.getArrivalsExpectByPack(resp?.data);

            for (const good of this.waitingGoods) {
                const dt = waitingDateByWar[Number(good.pack_id)];
                good.waiting_expect = dt ? moment(dt.expect).format('DD.MM') : '';
                // позначка «інший склад: …», якщо товар очікується лише не на складі доставки клієнта (#446)
                good.waiting_expect_note = dt ? dt.note : '';
                // Повна дата для сортування груп: ключ 'DD.MM' без року, і в грудні «05.01» ставало перед «28.12»
                good.waiting_expect_at = dt ? moment(dt.expect).valueOf() : 0;
            }

            // Пошук, введений поки вантажились дати, не скидаємо: порожній фільтр - це весь список
            this.searchWaitingGoods();
          });
      });

    this.isModalExpectedReceiptOfGoodsShow = true;
    this.isDarkBackground = true;
  }

  private rebuildGroups(filteredWaitingGoods) {
    const groups= {};
    const groupsAt = {};
    const groupsDate = {};
    const groupsNote = {};
    this.waitingGoodsNoDate = [];

    for (const good of filteredWaitingGoods) {
      if (!good.waiting_expect) {
        this.waitingGoodsNoDate.push(good);
        continue;
      }

      // Товари з датою іншого складу - окрема група на ту ж дату, з позначкою складу в заголовку (#446)
      const note = good.waiting_expect_note || '';
      const key = good.waiting_expect + (note ? ' ' + note : '');

      if (!groups[key]) groups[key] = [];
      groups[key].push(good);
      groupsAt[key] = good.waiting_expect_at || 0;
      groupsDate[key] = good.waiting_expect;
      groupsNote[key] = note;
    }

    this.groupedWaitingGoods = Object.keys(groups)
      // за датою, на одну дату спочатку свій склад, потім інший
      .sort((a, b) => (groupsAt[a] - groupsAt[b]) || ((groupsNote[a] ? 1 : 0) - (groupsNote[b] ? 1 : 0)))
      .map(key => ({
        date: groupsDate[key],
        note: groupsNote[key],
        items: groups[key],
      }));
  }

  searchWaitingGoods() {
    const waitingGoods  = cloneDeep(this.waitingGoods);

    const searchTerm = this.filterWaitingGoods.toLowerCase().trim();

    this.filteredWaitingGoods = waitingGoods.filter(good => {
      const name = good.good_name?.toLowerCase() || '';
      const article = good.artikul?.toLowerCase() || '';
      return name.includes(searchTerm) || article.includes(searchTerm);
    });

    this.rebuildGroups(this.filteredWaitingGoods);
  }

  crossClearsSearchField() {
    this.filterWaitingGoods = '';
    this.filteredWaitingGoods = [...this.waitingGoods];
    this.rebuildGroups(this.filteredWaitingGoods);
  }

  closeModal() {
    this.isModalExpectedReceiptOfGoodsShow = false;
    this.isDarkBackground = false;
  }

  ngOnDestroy() {
    this.isDestroyed.next(true);
    this.isDestroyed.complete();
  }
}
